
import React, { useCallback, useRef, useEffect } from 'react';

interface PreviewIframeProps {
  renderedHtml: string;
  isLoading: boolean;
  onLoad: () => void;
  onError?: (error: Error) => void;
}

export const PreviewIframe = ({ renderedHtml, isLoading, onLoad, onError }: PreviewIframeProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  
  const handleIframeLoad = useCallback(() => {
    console.log('Iframe onload event fired');
    onLoad();
  }, [onLoad]);

  const handleIframeError = useCallback((error: ErrorEvent) => {
    console.error('Iframe error:', error);
    if (onError) onError(new Error('Failed to render preview'));
  }, [onError]);
  
  // Force update iframe content when renderedHtml changes
  useEffect(() => {
    if (!renderedHtml || !iframeRef.current) return;
    
    try {
      // Force iframe update by directly updating the document
      const iframeDoc = iframeRef.current.contentDocument;
      if (iframeDoc) {
        iframeDoc.open();
        iframeDoc.write(renderedHtml);
        iframeDoc.close();
        console.log('Updated iframe content directly, length:', renderedHtml.length);
      }
    } catch (error) {
      console.error('Error updating iframe content:', error);
      if (onError && error instanceof Error) onError(error);
    }
  }, [renderedHtml, onError]);
  
  return (
    <iframe
      ref={iframeRef}
      title="Email Preview"
      srcDoc={renderedHtml}
      className="w-full h-full bg-white"
      style={{ 
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        border: 'none',
        opacity: isLoading ? 0 : 1,
        transition: 'opacity 0.3s ease-in-out'
      }}
      sandbox="allow-same-origin"
      onLoad={handleIframeLoad}
      onError={handleIframeError as any}
    />
  );
};
